import { genComponentStyleHook, type FullToken } from './styleUtil'
import { background, getBorderStyle } from './gradientUtil'
import { DOT_PREFIX } from './constant'

export const genStyle = (token: FullToken) => {
  const { componentCls, lineWidth } = token
  return {
    [`${DOT_PREFIX}${componentCls}-wrapper`]: {
      [componentCls]: {
        '&:before': [
          ...getBorderStyle(lineWidth),
          { inset: 0 },
        ],
        [`&${componentCls}-checked ${componentCls}-inner`]: {
          background: `${background} !important`,
        },
      },
      '&-disabled': {
        [componentCls]: {
          '&:before': { opacity: token.opacityLoading },
        },
      },
    },
  }
}

export default genComponentStyleHook(['Checkbox', 'techTheme'], (token: FullToken) => {
  return [genStyle(token)]
})
